import { createSlice } from '@reduxjs/toolkit';
import { useSelector as _useSelector, type TypedUseSelectorHook } from 'react-redux';

type CrawlerUpdateAnnouncementPageState = {
  viewedEventSent: boolean;
};

const useSelector: TypedUseSelectorHook<{
  aiInsightsCrawlerUpdateAnnouncement: CrawlerUpdateAnnouncementPageState;
}> = _useSelector;

const initialState: CrawlerUpdateAnnouncementPageState = {
  viewedEventSent: false,
};

const crawlerUpdateAnnouncementSlice = createSlice({
  name: 'AiInsightsCrawlerUpdateAnnouncement',
  initialState,
  reducers: {
    markViewedEventSent: (state) => {
      state.viewedEventSent = true;
    },
  },
});

export const { markViewedEventSent } = crawlerUpdateAnnouncementSlice.actions;
export const useIsViewedEventSent = () =>
  useSelector((state) => state.aiInsightsCrawlerUpdateAnnouncement.viewedEventSent);
export default crawlerUpdateAnnouncementSlice.reducer;
